const dev = {
  WEBAPP_URL: 'http://localhost:3000',
  API_URL: 'http://localhost:3333',
  CDN_URL: 'http://localhost:3336',
  OAUTH: {
    GOOGLE: {
      CLIENT_ID:
        '858270128372-3cfonf26jglbf6n68hre9k3unslqoifp.apps.googleusercontent.com'
    }
  },
  GOOGLE_ANALYTICS_ID: 'G-XXXXXXXXXX',
  AMPLITUDE_API_KEY: '4e140c2723c8c96c4cd0c341e990e252',
  TRAKT_CLIENT_ID:
    '635c4bb2d4ec9668dabdbcd69139ca4ec3f3cb5ca25e728792ff64c7aa05cf00'
};

const prod = {
  WEBAPP_URL: 'https://trakio.app',
  API_URL: 'https://api.thecinehub.app',
  CDN_URL: 'https://static.trakio.app',
  OAUTH: {
    GOOGLE: {
      CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID as string
    }
  },
  GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
  AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY as string,
  TRAKT_CLIENT_ID: process.env.NEXT_PUBLIC_TRAKT_CLIENT_ID
};

export default process.env.NODE_ENV === 'development' ? dev : prod;
